{
  "shell": {
    "headline": "One space for your whole school.",
    "subheadline": "Sign in to continue — lessons, classes and progress, all in one place.",
    "highlights": {
      "school": {
        "title": "Built for schools and tutors",
        "text": "Run an organization with a full staff, or teach on your own — the platform adapts."
      },
      "secure": {
        "title": "Private & secure",
        "text": "Each role sees only what is meant for it — admins, teachers, pupils and parents."
      },
      "bilingual": {
        "title": "English and Ukrainian",
        "text": "The whole platform speaks both languages — switch any time."
      }
    }
  },
  "login": {
    "title": "Sign in",
    "description": "Use your Osvitly account to continue.",
    "email": "Email",
    "emailPlaceholder": "you@school.edu",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "noAccount": "New to Osvitly?",
    "registerLink": "Create an account",
    "failed": "Sign in failed"
  },
  "register": {
    "title": "Create your account",
    "description": "One account for every school you belong to.",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "submit": "Create account",
    "submitting": "Creating account…",
    "haveAccount": "Already have an account?",
    "loginLink": "Sign in",
    "failed": "Registration failed",
    "verifyEmailTitle": "Check your inbox",
    "verifyEmailText": "We sent a verification link to {{email}}. Verify your email, then sign in.",
    "goToLogin": "Go to sign in"
  },
  "forgot": {
    "title": "Reset your password",
    "description": "Enter your Osvitly email and we'll send a reset link.",
    "sentDescription": "If an account exists for that email, a reset link is on its way.",
    "email": "Email",
    "submit": "Send reset link",
    "submitting": "Sending…",
    "backToLogin": "Back to sign in"
  },
  "reset": {
    "title": "Set your password",
    "description": "Choose a password for your Osvitly account.",
    "doneDescription": "You're all set — sign in to Osvitly.",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "submit": "Set password",
    "submitting": "Saving…",
    "continueToLogin": "Continue to sign in",
    "linkMissing": "This link is missing its security token. Open the most recent email, or request a new one.",
    "linkInvalid": "This link is invalid or has expired. Request a new reset email.",
    "backToLogin": "Back to sign in"
  },
  "invite": {
    "checking": "Checking your invitation…",
    "bannerTitle": "You've been invited",
    "bannerText": "{{name}} invited you to join {{school}} as {{role}}.",
    "bannerClass": "Class: {{class}}",
    "emailLocked": "This invitation sets your email address.",
    "invalidTitle": "This invitation link isn't valid",
    "invalidText": "It may have expired or been used already. You can still create an account without it.",
    "plainSignup": "Continue with a regular sign-up"
  },
  "validation": {
    "emailRequired": "Email is required",
    "emailInvalid": "Enter a valid email",
    "passwordRequired": "Password is required",
    "passwordMin": "Use at least 8 characters",
    "passwordConfirmRequired": "Confirm your password",
    "passwordMismatch": "Passwords do not match",
    "firstNameRequired": "First name is required",
    "lastNameRequired": "Last name is required"
  },
  "userMenu": {
    "open": "Open user menu",
    "signOut": "Sign out"
  }
}
